import { isDesktopSafari, isFirefox, isInternetExplorer, isMobile } from '@lemonade-hq/cdk';
import { useCallback, useEffect, useRef } from 'react';

const MOUSE_WHEEL_BASE_DELTA = 110;

export interface ExtendedWheelEvent extends WheelEvent {
  wheelDeltaY: number; // safari only
}

export default function useTrackPad(): { isTrackPad: boolean } {
  const detected = useRef(false);
  const isTrackPad = useRef(true);

  const detectTrackPad = useCallback((e: Event) => {
    const mouseWheelEvent = e as ExtendedWheelEvent;
    if (!detected.current) {
      isTrackPad.current = isDesktopSafari()
        ? mouseWheelEvent.wheelDeltaY === mouseWheelEvent.deltaY * -3
        : Math.abs(mouseWheelEvent.wheelDeltaY) < MOUSE_WHEEL_BASE_DELTA;
      detected.current = true;
      removeListeners();
    }
  }, []);

  const detectTrackPadFirefox = useCallback((e: WheelEvent) => {
    isTrackPad.current = e.deltaMode === 0;
    removeListeners();
  }, []);

  const removeListeners = useCallback(() => {
    document.removeEventListener('mousewheel', detectTrackPad);
    document.removeEventListener('DOMMouseScroll', detectTrackPad);
    document.removeEventListener('wheel', detectTrackPadFirefox);
  }, [detectTrackPadFirefox, detectTrackPad]);

  useEffect(() => {
    if (isMobile() || isInternetExplorer()) return;

    if (isFirefox()) {
      document.addEventListener('wheel', detectTrackPadFirefox, {
        passive: false,
      });
    } else {
      document.addEventListener('mousewheel', detectTrackPad, {
        passive: false,
      });
      document.addEventListener('DOMMouseScroll', detectTrackPad, {
        passive: false,
      });
    }

    return removeListeners;
  }, [detectTrackPad, detectTrackPadFirefox, removeListeners]);

  return { isTrackPad: isTrackPad.current };
}
